import { FC, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import Block from "../components/Block.component";
import { Card, CardBody, CardSubtitle, CardTitle, Col, Label, Row } from "reactstrap";
import Cookies from 'universal-cookie';
import imgREDECO from "../assets/imgs/REDECO.png";
import imgREUNE from "../assets/imgs/REUNE.png";
import DeviceConfig from "../config/Device.config";
import { Logout } from "@mui/icons-material";
import Swal from "sweetalert2";
import colors from "../config/Colors.config";
import Tiempo from "../tools/Tiempo.tool";
import UsuarioModel from "../models/Usuario.model";


const cookies = new Cookies();

const Dashboard: FC = () => {

    const [device, setDevice] = useState(DeviceConfig.getData());

    useEffect(() => {
        cargarDatos();
        validarToken();
    }, []);

    const cargarDatos = (): void => {
        setDevice(DeviceConfig.getData());
    }

    const validarToken = (): void => {
        const token: string = UsuarioModel.getToken();
        if (token.length === 0) {
            document.body.innerHTML = "<body></body>";
            Swal.fire({
                icon: "warning",
                title: "Acceso Denegado",
                text: `Debes iniciar sesión para poder usar el sistema`,
                showConfirmButton: true,
                confirmButtonColor: colors.dorado01,
                confirmButtonText: "Ok",
                timerProgressBar: true,
                reverseButtons: true,
                timer: 10000
            }).then(async (response) => {
                if (response.isConfirmed) {
                    cookies.remove("usuario");
                    Tiempo.sleep(0.5).then(() => window.location.href = "/");
                }
            });
            Tiempo.sleep(10).then(() => window.location.href = "/");
        }
    }

    return (
        <section style={{ width: "100%", height: "100vh" }} >

            <ToastContainer limit={3} position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
            <Block height={70} />
            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5 }} >

                <Col style={{ textAlign: "right" }} >
                    <Logout style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            Swal.fire({
                                icon: "question",
                                title: "Salir del Sistema",
                                text: `¿Estas seguro de que quieres salir del sistema?`,
                                showConfirmButton: true,
                                confirmButtonColor: colors.dorado01,
                                showCancelButton: true,
                                cancelButtonText: "No",
                                confirmButtonText: "Si",
                                timerProgressBar: true,
                                reverseButtons: true,
                                timer: 10000
                            }).then(async (response) => {
                                if (response.isConfirmed) {
                                    cookies.remove("usuario");
                                    Tiempo.sleep(0.5).then(() => window.location.href = "/");
                                }
                            });
                        }}
                    >
                        Salir del Sistema
                    </Label>
                </Col>
            </Row>
            {
                device.isDesktop ?
                    <Row style={{ marginRight: "10%", marginLeft: "10%", marginTop: "10vh" }} >
                        <Col style={{ minWidth: device.isDesktop ? "50%" : "100%", width: device.isDesktop ? "50%" : "100%", maxWidth: device.isDesktop ? "50%" : "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Card
                                style={{ width: '18rem', borderRadius: 12, height: 300, marginRight: 60, cursor: "pointer" }}
                                onClick={() => {
                                    window.location.href = "/quejas"
                                }}
                            >
                                <center>
                                    <img
                                        alt="Sample"
                                        src={imgREDECO}
                                        style={{ marginTop: 55, marginRight: 0, marginLeft: 0 }}
                                    />
                                </center>
                                <CardBody>
                                    <CardTitle tag="h3" style={{ textAlign: "center" }}>
                                        QUEJAS
                                    </CardTitle>
                                    <CardSubtitle
                                        className="mb-2 text-muted"
                                        tag="h5"
                                        style={{ textAlign: "center" }}
                                    >
                                        CONDUSEF
                                    </CardSubtitle>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "50%" : "100%", width: device.isDesktop ? "50%" : "100%", maxWidth: device.isDesktop ? "50%" : "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>

                            <Card
                                style={{ width: '18rem', borderRadius: 12, height: 300, marginLeft: 60, cursor: "pointer" }}
                                onClick={() => {
                                    window.location.href = "/reune/panel"
                                }}
                            >
                                <center>
                                    <img
                                        alt="Sample"
                                        src={imgREUNE}
                                        style={{ marginTop: 30, marginRight: 0, marginLeft: 0 }}
                                    />
                                </center>
                                <CardBody>
                                    <CardTitle tag="h3" style={{ textAlign: "center" }}>
                                        Consultas, Reclamaciones y Aclaraciones
                                    </CardTitle>
                                    <CardSubtitle
                                        className="mb-2 text-muted"
                                        tag="h5"
                                        style={{ textAlign: "center" }}
                                    >
                                        CONDUSEF
                                    </CardSubtitle>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    :
                    <>
                        <Row style={{ marginRight: 0, marginLeft: 0 }} >
                            <Col style={{ minWidth: "100%", width: "100%", maxWidth: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>

                                <Card
                                    style={{ width: '18rem', borderRadius: 12, height: 300, marginRight: 0, cursor: "pointer" }}
                                    onClick={() => {
                                        window.location.href = "/quejas"
                                    }}
                                >
                                    <center>
                                        <img
                                            alt="Sample"
                                            src={imgREDECO}
                                            style={{ marginTop: 55, marginRight: 0, marginLeft: 0 }}
                                        />
                                    </center>
                                    <CardBody>
                                        <CardTitle tag="h3" style={{ textAlign: "center" }}>
                                            QUEJAS
                                        </CardTitle>
                                        <CardSubtitle
                                            className="mb-2 text-muted"
                                            tag="h5"
                                            style={{ textAlign: "center" }}
                                        >
                                            CONDUSEF
                                        </CardSubtitle>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 30 }} >
                            <Col style={{ minWidth: device.isDesktop ? "50%" : "100%", width: device.isDesktop ? "50%" : "100%", maxWidth: device.isDesktop ? "50%" : "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>

                                <Card
                                    style={{ width: '18rem', borderRadius: 12, height: 300, marginLeft: 0, cursor: "pointer" }}
                                    onClick={() => {
                                        window.location.href = "/reune/panel"
                                    }}
                                >
                                    <center>
                                        <img
                                            alt="Sample"
                                            src={imgREUNE}
                                            style={{ marginTop: 30, marginRight: 0, marginLeft: 0 }}
                                        />
                                    </center>
                                    <CardBody>
                                        <CardTitle tag="h3" style={{ textAlign: "center" }}>
                                            Consultas, Reclamaciones y Aclaraciones
                                        </CardTitle>
                                        <CardSubtitle
                                            className="mb-2 text-muted"
                                            tag="h5"
                                            style={{ textAlign: "center" }}
                                        >
                                            CONDUSEF
                                        </CardSubtitle>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </>

            }

        </section >

    );


};

export default Dashboard;